module.exports = __webpack_public_path__ + "img/xian01.fe59bed4.png";